import React from "react";

const WelcomeMessage = ({ content, fetchData }) => {
  const hasContent = content && content.trim() !== '';
  
  // Check if content contains inline images (img tags)
  const hasInlineImage = hasContent && /<img\s+[^>]*src\s*=\s*["'][^"']+["'][^>]*>/i.test(content);
  
  // Determine layout type
  const isInlineImageLayout = hasInlineImage;

  const styles = {
    container: {
      maxWidth: '60%',
      margin: isInlineImageLayout ? '30px auto' : '50px auto',
      padding: '32px',
      backgroundColor: 'white',
      borderRadius: isInlineImageLayout ? '4px' : '12px',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1), 0 1px 8px rgba(0, 0, 0, 0.08)',
      overflow: 'hidden',
    },
    scrollWrapper: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingRight: '4px',  
      scrollbarWidth: 'thin',
      scrollbarColor: '#ef0e0a0e transparent',
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      minHeight: '100%',
    },
    content: {
      color: '#1f2937',
      textAlign: 'left',
      fontSize: '18px',
      maxWidth: '100%',
      marginBottom: '40px',
      width: '100%',
    },
    button: {
      padding: '15px 30px',
      backgroundColor: '#D22A27',
      color: '#ffffff',
      fontSize: '18px',
      fontWeight: '600',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: !isInlineImageLayout ? '0 4px 12px rgba(210, 42, 39, 0.3), 0 1px 3px rgba(0, 0, 0, 0.1)' : 'none',
      fontFamily: 'inherit',
      alignSelf: 'center',
    },
  };

  // Process content - handle inline images differently
  let processedContent = (content || "")
    .replace(/\\n\\n/g, '')
    .replace(/\\n/g, '');

  // Style inline images in content - FULL WIDTH
  if (hasInlineImage) {
    processedContent = processedContent.replace(
      /<img\s+([^>]*)>/gi,
      '<img $1 style="width: 100%; height: auto; max-height: 250px; display: block; margin: 16px 0; border-radius: 8px; object-fit: cover;"><br>'
    );
  }

  return (
    <div style={{...styles.container, ...styles.scrollWrapper}}>
      <div>
        <div style={styles.contentWrapper}>
          <div
            className="welcome-content"
            style={styles.content}
            dangerouslySetInnerHTML={{
              __html: processedContent,
            }}
          />

          <button
            onClick={fetchData}
            style={styles.button}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#b8201e';
              if (!isInlineImageLayout) {
                e.target.style.boxShadow = '0 6px 16px rgba(210, 42, 39, 0.4), 0 2px 6px rgba(0, 0, 0, 0.15)';
              }
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#D22A27';
              if (!isInlineImageLayout) {
                e.target.style.boxShadow = '0 4px 12px rgba(210, 42, 39, 0.3), 0 1px 3px rgba(0, 0, 0, 0.1)';
              } else {
                e.target.style.boxShadow = 'none';
              }
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Start Survey
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;